import { TitleCasePipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, input, output, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { DateTime } from 'luxon';
import { LuxonDatePipe } from '../../../../pipes/luxon-date.pipe';
import { AvatarAuraComponent } from '../../../media/avatar/avatar.component';
import { Activity } from './activity.types';

@Component({
  selector: 'aura-timeline-activity',
  templateUrl: './timeline-activity.component.html',
  imports: [MatIconModule, RouterLink, TitleCasePipe, LuxonDatePipe, AvatarAuraComponent],
})
export class TimelineActivityAuraComponent implements AfterViewInit {
  private readonly SCROLL_THRESHOLD = 200;

  activities = input.required<Activity[]>();
  loadMore = output<void>();

  @ViewChild('sentinel', { static: false }) sentinel?: ElementRef<HTMLDivElement>;

  ngAfterViewInit() {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.loadMore.emit();
      }
    });

    if (this.sentinel) {
      observer.observe(this.sentinel.nativeElement);
    }
  }

  isSameDay(current: string, compare: string): boolean {
    return DateTime.fromISO(current).hasSame(DateTime.fromISO(compare), 'day');
  }

  getRelativeFormat(date: string): string | null {
    return DateTime.fromISO(date).toRelativeCalendar();
  }

  trackByFn(index: number, item: Activity): unknown {
    return item.id || index;
  }
}
